<p-card header="Foto" class="w-full">
  <input #fileInput type="file" (change)="imageChangedEvent = $event" hidden />
  <div class="flex flex-col items-center gap-4">
    <div class="flex items-center flex-col md:flex-row gap-2">
      <p-button severity="primary" outlined label="Bild auswählen" (click)="fileInput.click()">
        <span class="material-symbols-outlined">upload</span>
      </p-button>
      @if (hasValidImage) {
        <p-button severity="danger" outlined="true" label="Bild zurücksetzen" (click)="resetImage(fileInput)">
          <span class="material-symbols-outlined">reset_image</span>
        </p-button>
      }
    </div>

    @if (imageChangedEvent !== undefined) {
      <div class="flex flex-col md:flex-row gap-4">
        <div class="flex flex-col gap-2">
          <h5>Zuschneiden</h5>
          <div class="cropper-container w-60 h-60 md:w-80 md:h-80">
            <image-cropper
              class="grow-0 shrink-0 basis-xs"
              [imageChangedEvent]="imageChangedEvent"
              [maintainAspectRatio]="true"
              [aspectRatio]="1"
              [resizeToWidth]="640"
              [onlyScaleDown]="true"
              [roundCropper]="true"
              format="jpeg"
              (imageCropped)="imageCropped($event)"
              (loadImageFailed)="loadImageFailed()"
            ></image-cropper>
          </div>
          <div class="flex flex-row items-center gap-1 ml-2">
            <p-toggle-switch inputId="blackWhiteToggle" [formControl]="blackWhite" class="mt-[4.5px]" />
            <label for="blackWhiteToggle">Schwarz-Weiß</label>
          </div>
        </div>
        <div class="flex flex-col gap-2">
          <h5>Vorschau</h5>
          <div class="preview-container">
            <img class="preview w-60 h-60 md:w-80 md:h-80" [src]="croppedImage" [style.filter]="imageFilter | async" alt="" />
          </div>
        </div>
      </div>
    }
  </div>
</p-card>
